import { IconsProps, ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { SearchFieldOption } from 'components/2-molecules/SearchFieldComponent/SearchFieldComponent';
import { Page } from 'context/PageContext';
import { apiInstanceCached, getAuthenticatedQuoteEndpoint, getBaseProxyUrl } from '../services/Api';
import { SearchComponent, SearchConfiguration, SearchObjectResponse, SearchResult } from './SearchConfiguration';

type SpdSearchResponse = {
	data: {
		URL?: string;
		name?: string;
		response?:
			| {
					default?: boolean;
					label?: string;
					value?: string;
			  }[]
			| SearchObjectResponse;
	};
};

export class SpdSearch implements SearchComponent {
	searchConfiguration: SearchConfiguration;
	apiSearch: boolean;
	searchIcon: IconsProps<ThemeUnion>['icon'];
	pageContext: Partial<Page>;
	spdBody?: any;

	constructor(searchConfiguration: SearchConfiguration, pageContext: Partial<Page>, spdBody?: any) {
		this.searchConfiguration = searchConfiguration;
		this.apiSearch = false;
		this.pageContext = pageContext;
		this.spdBody = spdBody;
	}

	init = async (): Promise<SearchResult> => {
		const metaAreaContent = this.pageContext?.metaArea?.items?.[0];

		const configuredUrl = this.searchConfiguration.url;
		const endpoint = getAuthenticatedQuoteEndpoint(
			metaAreaContent?.content?.quoteSearchConfigurationApiEndpoint?.url || ''
		);
		const url = configuredUrl
			? getAuthenticatedQuoteEndpoint(configuredUrl)
			: getBaseProxyUrl(this.pageContext.apiEndpoints, endpoint) || '';

		if (!url) {
			console.error('No URL defined for SPD search.');
			return [];
		}

		const method = this.searchConfiguration.httpMethod || 'GET';

		try {
			const requestBody = this.spdBody ?? {
				name: this.searchConfiguration.spdSearchConfigurationName,
				params: (this.searchConfiguration.inputFields?.items ?? []).map((item, index) => ({
					param_name: item.content.param || '',
					param_value:
						this.pageContext?.metaArea?.items[0]?.content?.staticFields?.items[index]?.content
							?.defaultValue || '',
				})),
			};

			const res: SpdSearchResponse = await apiInstanceCached()[method.toLowerCase()](url, requestBody);

			if (this.searchConfiguration.responseType === 'obj') {
				if (res?.data?.response && !Array.isArray(res.data.response)) {
					return res.data.response;
				}
				return {};
			}

			const options: SearchFieldOption[] = [];
			if (Array.isArray(res?.data?.response)) {
				res.data.response.forEach((element) => {
					options.push({
						label: element.label,
						value: element.value,
					});
				});
			}

			return options.sort((a, b) => a.label.localeCompare(b.label));
		} catch (error) {
			console.error('Error during SPD search:', error);
			throw error instanceof Error ? error : new Error('Unknown SPD search error');
		}
	};
}
